module.exports = __webpack_public_path__ + "img/1696399053904-pirt mirna yunia.jpg.13b262ec.webp";